export const category = {
  label: '',
  position: '',
  types: [],
};
